export class MenuConfig{
    route: string;
    menuItem: string;
    subItems: MenuConfig[];

    constructor(route: string, menuitem: string, subitems: MenuConfig[]){
        this.menuItem = menuitem;
        this.route = route;
        this.subItems = subitems;
    }
}


// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/shared/classes/MenuConfig.ts